// A divider dragged with a pointer (components/SplitPane, components/VSplit):
// `move` for each place while it is held, then `done` once as it is let go —
// or as the browser takes the pointer back (pointercancel: a touch turned
// into a scroll, a system gesture), which would otherwise leave `move`
// listening and the divider following the pointer after. `bodyClass` is on
// the body meanwhile, for the cursor and to keep text from being selected.

export function dragDivider(bodyClass: string, move: (e: PointerEvent) => void, done: () => void): void {
  const end = () => {
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", end);
    window.removeEventListener("pointercancel", end);
    document.body.classList.remove(bodyClass);
    done();
  };
  document.body.classList.add(bodyClass);
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", end);
  window.addEventListener("pointercancel", end);
}
